export const PAGE_SIZE = 20;

export const EMPTY_ACTEUR = {
  nom: "",
  prenom: "",
  email: "",
  tel: "",
  adresse: "",
  cp: "",
  commune: "",
  genre: "",
  date_naissance: "",
  photo_url: "",
  club_acteur: "",
  licence_number: "",
  groupe_souhaite: "",
};

export const USER_ROLE_LABELS = {
  1: "Administrateur",
  2: "Utilisateur",
  3: "Dirigeant Club",
  4: "Arbitrage",
  5: "Responsable Arbitrage",
  6: "Membre de la Ligue NA",
  7: "Responsable Comité Départemental",
  8: "Enseignant-Coach",
};